module.exports = __webpack_public_path__ + "img/DealerIcons-DisplayCreator-On.7f11fd4.jpg";